import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ExamConfig from './pages/ExamConfig';
import ExamPage from './pages/ExamPage';
import Results from './pages/Results';
import AnswerKey from './pages/AnswerKey';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/config" element={<ExamConfig />} />
          <Route path="/exam/:examId" element={<ExamPage />} />
          <Route path="/results/:examId" element={<Results />} />
          <Route path="/answer-key" element={<AnswerKey />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
